import { useEffect, useId, useState } from 'react';

const TIMES = Array.from({ length: 48 }, (_, index) => `${String(Math.floor(index / 2)).padStart(2, '0')}:${index % 2 ? '30' : '00'}`);
const QUICK = ['06:00', '06:30', '07:00', '07:30'];
const validTime = value => /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
export function formatPlannerTime(value) {
  if (!validTime(value)) return value;
  const [hour, minute] = value.split(':');
  return `${Number(hour) % 12 || 12}:${minute} ${Number(hour) < 12 ? 'AM' : 'PM'}`;
}

export default function PlannerStartTime({ value = '', onChange, testId, label = 'Start time' }) {
  const id = useId();
  const [custom, setCustom] = useState(false);
  const [draft, setDraft] = useState(value || '');
  const [error, setError] = useState(false);
  useEffect(() => { setDraft(value || ''); setCustom(false); setError(false); }, [value]);
  const controls = 'min-h-10 w-full rounded-sm border border-zinc-300 bg-white px-2 text-sm text-zinc-900 dark:border-slate-600 dark:bg-[#101e2e] dark:text-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#FF5F15]';
  const choose = time => { setCustom(false); setError(false); onChange(time); };
  const apply = () => {
    const normalized = draft.trim().replace(/^(\d):/, '0$1:');
    if (!validTime(normalized)) { setError(true); return; }
    choose(normalized);
  };
  return <div className="min-w-0 space-y-2" onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} draggable={false}>
    <label htmlFor={id} className="block text-xs">{label}</label>
    <select id={id} className={controls} data-testid={testId} value={custom ? 'custom' : value || ''} onChange={e => {
      if (e.target.value === 'custom') { setDraft(value || ''); setError(false); setCustom(true); }
      else choose(e.target.value);
    }}>
      <option value="">All day / Unspecified</option>
      {value && !TIMES.includes(value) && <option value={value}>{`${formatPlannerTime(value)} (custom)`}</option>}
      {TIMES.map(time => <option key={time} value={time}>{formatPlannerTime(time)}</option>)}
      <option value="custom">Custom time…</option>
    </select>
    <div className="flex flex-wrap gap-1" aria-label="Quick start times">{QUICK.map(time => <button key={time} type="button" aria-label={`Start at ${formatPlannerTime(time)}`} aria-pressed={value === time} onClick={() => choose(time)} className="min-h-10 min-w-11 rounded-sm border border-zinc-300 px-2 text-xs hover:bg-zinc-100 dark:border-slate-600 dark:hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#FF5F15]">{time.slice(1)}</button>)}</div>
    {custom && <div className="space-y-1">
      <label htmlFor={`${id}-custom`} className="block text-xs">Custom time (24-hour HH:mm)</label>
      <div className="flex gap-2"><input id={`${id}-custom`} className={controls} type="text" inputMode="text" placeholder="06:45" maxLength={5} value={draft} aria-invalid={error} aria-describedby={`${id}-hint`} onChange={e => { setDraft(e.target.value); setError(false); }} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); apply(); } }} /><button type="button" className="min-h-10 rounded-sm border border-zinc-300 px-3 text-sm dark:border-slate-600" onClick={apply}>Apply</button></div>
      <p id={`${id}-hint`} className={`text-xs ${error ? 'text-red-600 dark:text-red-400' : 'text-zinc-500 dark:text-slate-400'}`} role={error ? 'alert' : undefined}>{error ? 'Enter a time from 00:00 to 23:59.' : 'Press Apply to use this custom time.'}</p>
    </div>}
  </div>;
}
